import { Row as AntdRow } from "antd";
import React, { ReactNode } from "react";
import { RowProps as AntdRowProps } from "antd/es/grid/row";

export interface MyRowProps extends AntdRowProps {
  children?: ReactNode;
}

const RowPolyfill: React.FC<MyRowProps> = ({ children, ...props }) => {
  return <AntdRow {...props}>{children}</AntdRow>;
};

export default RowPolyfill;
